import { useMutation, useQuery, useQueryClient } from "react-query";
import { getUserScreenPreferences, saveUserScreenPreferences } from "@/api/App/UserPreferences/user-preferences-api";

export function useUserScreenPreferences(screenKey, options = {}) {
	return useQuery(["user-screen-preferences", screenKey], () => getUserScreenPreferences(screenKey), {
		enabled: options.enabled !== false,
		staleTime: 5 * 60 * 1000,
	});
}

export function useSaveUserScreenPreferences(screenKey) {
	const queryClient = useQueryClient();

	return useMutation(({ viewMode, visibleColumns }) => saveUserScreenPreferences({ screenKey, viewMode, visibleColumns }), {
		onSuccess: (_, variables) => {
			queryClient.setQueryData(["user-screen-preferences", screenKey], (previous) => ({
				...previous,
				view_mode: variables.viewMode,
				visible_columns: variables.visibleColumns ?? previous?.visible_columns ?? null,
			}));
		},
	});
}
